import { IconButton } from '@mui/material';
import { FC } from 'react';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

interface ShareData {
	title?: string;
	text?: string;
	url?: string;
}

export const ShareNavigator: FC<ShareData> = ({ title = '', url = '', text = '' }) => {
	const handleShare = () => {
		if (navigator.share) {
			navigator.share({ title, text, url });
		}
	};

	return (
		<IconButton onClick={handleShare}>
			<ShareOutlinedIcon className="h-7 w-7 text-text-disabled" />
		</IconButton>
	);
};
